import firebase from 'firebase';
import "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyAqi7VK5yvof2i57_4rZFXXdC-f_CtElDE",
    authDomain: "huddle-3dd7c.firebaseapp.com",
    projectId: "huddle-3dd7c",
    storageBucket: "huddle-3dd7c.appspot.com",
    messagingSenderId: "690563522966",
    appId: "1:690563522966:web:4b39bdd4f720d57160bdb7"
  };
  // Initialize Firebase
firebase.initializeApp(firebaseConfig);

export const firestore = firebase.firestore();